import app from 'flarum/forum/app';
import Avatar from 'flarum/common/components/Avatar';
// v0.6.62 — 操作类型改 Flarum 原生 Dropdown (辉哥 9/30 21:05 拍板: 不用原生 <select>)
import Dropdown from 'flarum/common/components/Dropdown';
import Button from 'flarum/common/components/Button';
import Api from '../utils/Api';
// v0.6.59 — 日期选择器公用 helper (辉哥 9/30 19:42 拍板: 操作日志 tab 加日期范围 filter)
// v0.6.60 — 改成单日期 (辉哥 9/30 20:45 拍板: 不要日期范围, 只要一个日期)
import { mountDatePicker } from '../utils/DatePickerHelper';
// 批 41 · 段① — 无限滚动 + IntersectionObserver 整套机制现在共用这个基类
//   (原来本文件抄了一份, LessonsTab / SalesTab / StudentLessonsModal 各抄一份)
//   ⚠️ 本文件只需在 oninit 里给 this.sentinelAttr; 其余 (滚动根 / observer / 重试 / 翻页) 全在基类里。
import InfiniteScrollBase from '../utils/InfiniteScroll';

/** 每页条数 —— 辉哥 10/13 拍板: 首屏 20 条, 往下滚动继续 20 条 (跟 StudentLessonsModal.js:118 同值) */
const PAGE_SIZE = 20;

/**
 * sentinel 唯一 id 计数器 —— 照抄 StudentLessonsModal.js:127 modalSeq 的做法,
 * 用来在 DOM 里认领「哪个 sentinel 是我的」, 避免抓到别的 tab 实例的 sentinel。
 */
let tabSeq = 0;

/**
 * v0.6.2 — 操作日志 tab (辉哥 9/25 12:13 拍板)
 *
 * 按时间从新→旧展示用户操作记录
 * - 操作人 (avatar + nickname @ username)
 * - 操作类型 (create/update/delete/extend)
 * - 操作对象 (target_type: target_id + description)
 * - 时间 (created_at)
 *
 * v0.6.59 — 加日期范围 filter (辉哥 9/30 19:42 拍板)
 *   默认范围 = 最近 7 天 (今天 + 前 6 天), start_date / end_date 走独立 date picker 各管一段
 *   (不用 flatpickr mode='range' 单 input, 辉哥诉求是 2 个独立 input UI 习惯)
 *   load() 传 start_date + end_date 给后端 controller
 *
 * v0.6.60 — 改成单日期 picker (辉哥 9/30 20:45 拍板: 不要范围, 只要一个日期)
 *   选中某一天就查那一天的日志, 默认 = 今天
 *   load() 改传 date 单 param 给后端 controller
 *
 * v0.6.61 — action dropdown filter (辉哥 9/30 20:52 拍板)
 *   date 旁边再加一个 <select> 下拉, 选项: 全部 / 创建 / 更新 / 删除 / 延期
 *   默认 'all' → 不传 action param (后端返回全部, 兼容老行为)
 *   选具体 action → load() 加 action=xxx param, 后端 white-list 校验后加 where('action', xxx)
 *   action 跟 date 独立, 两 filter 组合生效
 *
 * v0.6.62 — 操作类型改 Flarum 原生 Dropdown + mobile 同桌同一行 (辉哥 9/30 21:05 拍板)
 *   操作类型 <select> → Flarum 原生 Dropdown (跟 CardTemplatesTab.js 9/24 改造的 filter 同款)
 *   mobile 不再强制 wrap (v0.6.61 flex-wrap:wrap 各占满一行) → 同一行 (flex-wrap:nowrap + overflow-x:auto 兜底)
 *   desktop 跟 mobile UI 一致 (辉哥诉求: 桌面 + 移动都同一行, 不再 wrap)
 *
 * v0.6.62a — OperationLogs dropdown toggle 跟其他 tab 同款 (辉哥 9/30 21:17 拍板)
 *   Dropdown 加 buttonClassName="ZS-filter-dropdown-btn" + icon="fas fa-filter"
 *   跟 CardTemplatesTab.js / StudentsListTab.js / LessonsTab.js / StatsTab.js 同款
 *   (less/forum.less L164-185 已定义 .ZS-filter-dropdown-btn 深色面板 + padding 10px 14px + border 1px solid)
 *
 * v0.6.62b — OperationLogs dropdown menu 错位修复 (辉哥 9/30 21:36 反馈)
 *   Dropdown 加 lazyDraw={true}, 阻止 shown.bs.dropdown 异步 m.redraw() 把 menu className 重置
 *   (Vendor Dropdown.tsx L78-97: lazyDraw=false 走 m.redraw() 异步, mithril 把 <ul '>' className 写回
 *    'Dropdown-menu dropdown-menu ...', 抹掉 Bootstrap 的 .show class, menu 又变 display:none)
 *
 * ============================================================================
 * v0.17.16 — 改分页滚动加载 (辉哥 10/13 拍板, 4 项改造的第 1 项)
 *
 * ## 为什么改 (静默丢数据)
 *   改前 load() 写死 `limit: 200`, 后端 ListOperationLogsController 也默认 200 —— 超出部分
 *   被静默砍掉, 界面上**一个提示都没有**。本地实测单日峰值 2026-10-07 有 333 条 (砍掉 133),
 *   2026-10-10 有 205 条 (砍掉 5), 即 UI 上本来就有 138 条日志看不见。
 *
 * ## ★ 日志特有的坑: 滚动加载 × 日期筛选 = 「10/07 第 3 页混进 10/08」
 *   本 tab 天生就带一个 date 筛选器 (v0.6.60), 这是上课详情弹层没有的。三道防线:
 *   1) **切筛选 = offset 归零 + 带筛选参数重发**, 不是拿已加载的数组前端过滤, 也不是接着上一页
 *      往下 offset (那会取到新日期的第 3 页 —— 正是「串味」最常见的成因)。
 *   2) **竞态守卫 reqSeq**: 换日期时, 上一个日期还没回来的请求序号已过期, 响应回来整个丢弃,
 *      一个字段都不碰。否则「10/10 offset=40 的响应晚于「10/07 offset=0 的响应」到达」时,
 *      那 20 行会被 concat 到 10/07 的批次尾巴上, 界面同时出现两个日期的日志。
 *   3) **每批请求自带完整筛选参数** (school_id + date + action), 后端 total 与列表共用同一个
 *      作用域闭包 (见 ListOperationLogsController::$scope), 筛选与 offset 是同一份口径。
 *   另加 loadFirstPage() 里 `this.logs = []` 立即清空: 切筛选的瞬间屏幕上不留上一个日期的行。
 *
 * ## 响应信封跟着改成 {data, meta} (v0.17.16)
 *   改前读 `r.logs`, 改后读 `res.data` + `res.meta`。这个端点全站只有本组件一个消费方
 *   (AuditLog::query() 也只有那个 controller 一处读), 所以可以原地改结构。
 *   ⚠️ 改前 `stats.total = count($rows)` 是**本页返回行数**不是总数 (200 封顶时恒为 200),
 *      分页后已无法用来显示总数 —— 总数一律读新的 `meta.total`。
 *
 * ## 其它 (v0.17.15 已验证的实现, 不另创一套; 批 41 · 段① 起共用 utils/InfiniteScroll.js)
 *   - IntersectionObserver + findScrollRoot() / syncObserver() / scheduleSync()
 *     (现在共用 utils/InfiniteScroll.js —— 本文件只在 oninit 里给 this.sentinelAttr)
 *   - m.redraw() 本仓库不同步更新 DOM ⇒ 找不到 sentinel 时推到下一帧重试, 限次 5 次
 *   - onremove() 里 disconnect() + 撤掉排队中的 rAF
 * ============================================================================
 */
export default class OperationLogsTab extends InfiniteScrollBase {
  oninit(vnode) {
    super.oninit(vnode);
    this.activeSchoolId = vnode.attrs.activeSchoolId;
    this.loading = true;
    this.loadingMore = false;
    this.logs = [];
    // v0.6.60 — 单日期 filter state (默认今天, ISO 'YYYY-MM-DD' 字符串)
    this.selectedDate = this.todayIso();
    // v0.6.61 — action dropdown filter state (辉哥 9/30 20:52 拍板: 加增/删/改 筛选)
    //   默认 'all' → 不传 action param, 后端返全部 (跟 v0.6.2 老行为兼容)
    this.selectedAction = 'all';
    // ── v0.17.16 分页状态 (跟 StudentLessonsModal.js 同款命名, 方便两边对照) ──
    this.meta = null; // 后端汇总 (total / limit / offset / has_more)
    this.offset = 0; // 已加载条数 (= 下一批的 offset)
    this.reqSeq = 0; // 竞态守卫: 只有最新一次请求的结果算数
    this.paginatedOnce = false; // 是否翻过页 —— 决定要不要显示「已全部加载」
    // v0.18.57 — 后端说「请先选校区」(meta.need_school === true) 时的标志位
    //   改前: 后端对「没选校区」返回**空数组**, 前端一律显示「暂无操作记录 / 共 0 条」
    //         ⇒ 用户以为「这个时段没有操作」, 实际含义是「必须先选校区」。
    //   改后: 后端在 meta 里带 need_school, 这里只**换文案**, 布局/颜色/字号/图标一律不动。
    this.needSchool = false;
    this._observer = null; // IntersectionObserver 实例
    this._syncRaf = null; // 待执行的 rAF (syncObserver 重试), 关闭时要撤掉
    this._destroyed = false; // onremove 置 true —— 卸载后不再建 observer (防泄漏)
    this._sid = 'zlog' + ++tabSeq; // 本实例 sentinel 的 DOM 认领 id
    // 批 41 · 段① — 哨兵 DOM 属性名 (共用基类 utils/InfiniteScroll.js 按它认领 sentinel)
    this.sentinelAttr = 'data-zlogsid';
    this.loadFirstPage();
  }

  // v0.6.59a — picker 初始化时机 (Bug #2 修)
  //   - oncreate: DOM 就绪后 setTimeout 0 再试 (flatpickr vendor 要 ready)
  //   - onupdate: v0.6.59 阶段重复调 initDateRangePicker, 会触发 load()→m.redraw()→input 节点被替换→flatpickr 内部
  //     w.input.type='hidden' 被 Mithril 重置回 'text' → 同一行出现 2 个 input 报错 (实际 V 测发现的 4 input bug)
  //     现在改成只在 oncreate 调一次, 后续 initSingleDatePicker 由 _datePickerReady 幂等守住, m.redraw 不再重 mount
  //     DatePickerHelper.onReady 仍保留 type='hidden' 兜底作为二次保险
  oncreate(vnode) {
    super.oncreate(vnode);
    setTimeout(() => this.initSingleDatePicker(), 0);
  }
  onupdate(vnode) {
    super.onupdate(vnode);
    // v0.6.59a — Bug #2 修, onupdate 不再调 initSingleDatePicker, 防止 m.redraw 重 mount 导致 text input 重置 visible
  }
  onremove(vnode) {
    super.onremove(vnode);
    // ⚠️ v0.17.16 — 卸载标记。**必须**在 disconnect 之前置位:
    //   翻页请求可能在 tab 切走之后才回来, finally 里会调 syncObserver();
    //   没有这道闸, 它会给一个已经没人管的节点建 observer —— 那就是泄漏。
    this._destroyed = true;
    // ⚠️ v0.17.16 — 必须拆掉 IntersectionObserver。漏掉这里 = 每次切走这个 tab 泄漏一个 observer,
    //   observer 持有 sentinel 引用, sentinel 持有已经离屏的 DOM (验收判据 6)。
    this.disconnectObserver();
    // 撤掉排队中的重试帧 —— 否则 tab 切走了它还会醒来跑一次 syncObserver
    if (this._syncRaf) {
      cancelAnimationFrame(this._syncRaf);
      this._syncRaf = null;
    }
    // v0.6.59 — picker destroy (防 flatpickr 实例泄漏, 跟 CalendarTab onremove 同款)
    // v0.6.60 — 单 picker 实例 _fp (替代 v0.6.59 的 _startFp + _endFp)
    if (this._fp) {
      this._fp.destroy();
      this._fp = null;
    }
    this._datePickerReady = false;
  }
  redraw() {
    if (typeof m !== 'undefined' && m && typeof m.redraw === 'function') m.redraw();
  }

  // v0.6.59 — today 工具 (本地时区, 跟 v0.6.39 CalendarTab 时区约定一致)
  // v0.6.60 — 删 daysAgoIso (单日期 picker 不需要 N 天前)
  todayIso() {
    const d = new Date();
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }

  /* ═══════════════════════ 数据加载 (v0.17.16 分页) ═══════════════════════ */

  /** 首屏 / 换筛选: 清空重取 (offset 归零)
   *
   * ⚠️ 日志特有: 换日期/换动作**必须**走这里, 不能只改 this.selectedDate 就发下一页请求 ——
   *   那会让新日期从旧 offset 继续取 (「10/07 的第 3 页混进 10/08」的根因)。
   *   this.logs = [] 立即清空 ⇒ 切筛选瞬间屏幕上不留上一个筛选的行。
   */
  loadFirstPage() {
    this.logs = [];
    this.offset = 0;
    this.meta = null;
    this.paginatedOnce = false;
    // v0.18.57 — 换筛选时把「请先选校区」标志位复位 (否则上一轮的状态会粘在新筛选上)
    this.needSchool = false;
    this.loading = true;
    this.disconnectObserver();
    this.redraw();
    this.fetchPage(0, 'replace');
  }

  /**
   * 拉一页。
   *
   * @param {number}  offset
   * @param {'replace'|'append'}  mode  replace=替换 (首屏/换筛选) / append=追加 (滚动)
   */
  async fetchPage(offset, mode) {
    // 每次请求领一个递增序号; 响应回来时序号不是最新的就**整个丢弃**。
    // 这是防串味的核心: 换日期时上一个日期的请求还在路上, 它的响应必须被丢掉,
    // 否则那些行会被 concat 到新日期的批次尾巴上。
    const seq = ++this.reqSeq;
    try {
      // ⚠️ 每批请求都带**完整**筛选参数 —— 前端不缓存任何筛选状态给后端猜
      const params = {
        school_id: this.activeSchoolId,
        limit: PAGE_SIZE,
        offset: offset,
        // v0.6.60 — 单日期 param (替代 v0.6.59 的 start_date + end_date)
        date: this.selectedDate
      };
      // v0.6.61 — action dropdown param (辉哥 9/30 20:52 拍板)
      //   'all' 不传 → 后端返全部 (兼容 v0.6.2 老行为)
      //   具体 action → 后端 white-list 校验后加 where('action', xxx)
      if (this.selectedAction && this.selectedAction !== 'all') {
        params.action = this.selectedAction;
      }
      const res = await Api.get('operation-logs', params);
      // ★ 过期响应直接扔掉, 一个字段都不碰
      if (seq !== this.reqSeq) return;
      const rows = res && res.data || [];
      this.meta = res && res.meta || null;
      // v0.18.57 — 后端在「没选校区」时带 meta.need_school ⇒ 空态文案换成「请先选择校区…」
      //   ⛔ 只有 true 才算 —— 标志位缺失 / false 时走**原有**空态文案与渲染路径, 一行都不改。
      this.needSchool = !!(this.meta && this.meta.need_school === true);
      this.logs = mode === 'replace' ? rows : this.logs.concat(rows);
      // 下一批的 offset = 本批起点 + 本批实际行数 (用行数而不是 limit, 最后一页不满 20 时才对)
      this.offset = offset + rows.length;
      if (mode === 'append') this.paginatedOnce = true;
    } catch (e) {
      if (seq !== this.reqSeq) return;
      console.error('[zs] operation logs page load failed', e);
      if (mode === 'replace') this.logs = [];
    } finally {
      // ⚠️ 只有最新那次请求才允许改 loading 标志 —— 被丢弃的旧请求如果也去改,
      //    会把新一轮请求的 loading 提前清掉, 造成重复触发。
      if (seq === this.reqSeq) {
        this.loading = false;
        this.loadingMore = false;
      }
      this.redraw();
      this.syncObserver();
    }
  }

  /* ═══════════════════════ IntersectionObserver (现在共用 utils/InfiniteScroll.js) ═══════════════════════ */
  //
  //   findSentinel / findScrollRoot / disconnectObserver / syncObserver / scheduleSync / loadNextPage
  //   六个方法已挪到共用基类 utils/InfiniteScroll.js (批 41 · 段①)。
  //   三个坑 (滚动根误选 body / m.redraw 不同步 ⇒ observer 建不出来 / 孤儿 observer 泄漏)
  //   的实测根因注释全部随方法一起搬进了那个文件 —— 改滚动逻辑**只改那一处**。
  //
  //   本文件与滚动有关的私有数据只剩两个: this.sentinelAttr (见 oninit) + this._sid (DOM 认领 id)。

  /* ═══════════════════════ 汇总 (只读 meta) ═══════════════════════ */

  /** 筛选条件下的总条数 —— 一律读 meta.total, **不再**用 this.logs.length */
  totalCount() {
    return this.meta ? Number(this.meta.total) || 0 : 0;
  }

  // v0.6.60 — 单日期 picker 初始化 (辉哥 9/30 20:45 拍板)
  //   1 个 date picker (mode='date'), 选中某一天就查那一天的日志
  //   helper 内部 waitForVendor() 等 vendor ready, input 不存在 (loading 态) 时 return 兜底
  async initSingleDatePicker() {
    if (this._datePickerReady) return; // 已初始化, 幂等
    const input = this.element && this.element.querySelector('.ZS-log-date-picker');
    if (!input) return; // DOM 还没准备好 (loading 态), 留给后续 setTimeout retry

    // 单 picker — onChange 同步 selectedDate + 重 load
    this._fp = await mountDatePicker(input, {
      mode: 'date',
      defaultDate: this.selectedDate,
      onChange: selectedDates => {
        if (selectedDates.length > 0) {
          this.selectedDate = this.toIsoDate(selectedDates[0]);
          // v0.17.16 — 必须 loadFirstPage (offset 归零), 不能沿用旧 offset 接着往下取
          this.loadFirstPage();
        }
      }
    });

    // picker ready 才标记幂等, 防止部分 init 时被反复重入
    if (this._fp) {
      this._datePickerReady = true;
    }
  }

  // Date → 'YYYY-MM-DD' 本地时区 (flatpickr selectedDates 给 Date 对象, 转到 ISO 字符串给后端)
  toIsoDate(d) {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }

  // v0.6.62 — 操作类型 → 中文 label (辉哥 9/30 21:05 拍板: 改 Flarum 原生 Dropdown)
  //   顺序: 全部 / 创建 / 更新 / 删除 / 延期 (跟 v0.6.61 原生 <select> 同顺序)
  //   'all' → 不传 action param 给后端 (兼容 v0.6.2 老行为)
  actionOptions() {
    return [{
      value: 'all',
      label: '全部'
    }, {
      value: 'create',
      label: '创建'
    }, {
      value: 'update',
      label: '更新'
    }, {
      value: 'delete',
      label: '删除'
    }, {
      value: 'extend',
      label: '延期'
    }];
  }

  // 当前 selectedAction 对应的中文 label (给 Flarum Dropdown button label 用)
  selectedActionLabel() {
    const opt = this.actionOptions().find(o => o.value === this.selectedAction);
    return opt ? opt.label : '全部';
  }

  // v0.6.62 — Dropdown Button onclick 用 (辉哥 9/30 21:05 拍板)
  //   同步 selectedAction + 重 load (跟 v0.6.61 原生 <select> onchange 行为一致)
  setAction(value) {
    if (this.selectedAction === value) return; // 点当前项不发请求 (跟 StudentLessonsModal.setFilter 同款)
    this.selectedAction = value;
    // v0.17.16 — 换动作筛选 = offset 归零 + 带 action 参数重新请求,
    //   不是在前端已加载的那 20 条里过滤 (那样切「延期」只能筛出这 20 条里的延期)
    this.loadFirstPage();
  }

  // 操作类型 → 图标 + 文案 + 颜色
  actionBadge(action) {
    const map = {
      create: {
        icon: 'fa-plus',
        text: '创建',
        color: 'var(--zs-success-10b981, #10b981)'
      },
      update: {
        icon: 'fa-pen',
        text: '更新',
        color: 'var(--zs-brand-3b82f6, #3b82f6)'
      },
      delete: {
        icon: 'fa-trash',
        text: '删除',
        color: 'var(--zs-danger-ef4444, #ef4444)'
      },
      extend: {
        icon: 'fa-clock',
        text: '延期',
        color: 'var(--zs-warning-f59e0b, #f59e0b)'
      }
    };
    return map[action] || {
      icon: 'fa-circle',
      text: action,
      color: 'var(--zs-text-2-9ca3af, #9ca3af)'
    };
  }

  // 目标类型 → 中文
  targetLabel(type) {
    const map = {
      student: '学员',
      student_card: '学员卡',
      school: '校区',
      sale: '销售跟进',
      lesson: '课表',
      room: '教室',
      coach: '教练',
      sales: '销售'
    };
    return map[type] || type;
  }
  rowView(log) {
    const badge = this.actionBadge(log.action);
    const targetLabel = this.targetLabel(log.target_type);
    const actorName = log.actor_nickname ? `${log.actor_nickname} @${log.actor_username}` : log.actor_username || `#${log.actor_id}`;
    return m("div", {
      className: "ZS-log-row",
      key: log.id
    }, (() => {
      const userModel = log.actor_id ? app.store.getById('users', log.actor_id) : null;
      const fallbackLetter = (log.actor_display_name || log.actor_username || '?').charAt(0);
      return m("span", {
        className: "Avatar Avatar--size Avatar--color",
        style: "width:32px;height:32px;"
      }, userModel ? m(Avatar, {
        user: userModel
      }) : m("span", {
        className: "Avatar-letter",
        style: "display:flex;align-items:center;justify-content:center;width:32px;height:32px;background:var(--zs-surface-1-374151, #374151);color:var(--zs-text-1-e5e7eb, #e5e7eb);border-radius:50%;font-weight:600;"
      }, fallbackLetter));
    })(), m("div", {
      className: "ZS-log-content"
    }, m("div", {
      className: "ZS-log-line-1"
    }, m("span", {
      className: "ZS-log-actor"
    }, actorName), m("span", {
      className: "ZS-log-action",
      style: 'color:' + badge.color + ';'
    }, m("i", {
      className: 'fas ' + badge.icon,
      "aria-hidden": "true"
    }), ' ', badge.text), m("span", {
      className: "ZS-log-target"
    }, targetLabel, " #", log.target_id)), log.description && m("div", {
      className: "ZS-log-desc"
    }, log.description)), m("div", {
      className: "ZS-log-time"
    }, log.created_at));
  }

  // v0.6.60 — 单日期 picker UI (辉哥 9/30 20:45 拍板: 不要范围, 只要一个日期)
  //   1 个 .ZS-date-input-text + label "选择日期:", 共享 .ZS-date-input-text dark 样式
  // v0.6.61 — action dropdown filter (辉哥 9/30 20:52 拍板)
  //   同一行再加 1 个 label + 1 个 <select> 下拉 (5 选项: 全部/创建/更新/删除/延期)
  //   原生 <select>, mobile 走 UA native picker (跟 date input 体验一致)
  //   不用 Flarum 2.0 复杂 Dropdown 组件 (辉哥没要求 + 单选 + 简单稳定优先)
  //
  // v0.6.62 — 操作类型改 Flarum 原生 Dropdown (辉哥 9/30 21:05 拍板)
  //   原生 <select> → Flarum <Dropdown> + <Button active> (跟 CardTemplatesTab.js v0.5.0q 同款 pattern)
  //   5 选项映射 actionOptions() / 当前 label selectedActionLabel() / 切换 setAction()
  //   menuClassName 加 .ZS-log-action-menu 给 LESS 配 z-index 兜底 (防被 stacking 容器遮)
  //
  // v0.6.62a — dropdown toggle 走 .ZS-filter-dropdown-btn class (辉哥 9/30 21:17 拍板)
  //   加 buttonClassName="ZS-filter-dropdown-btn" + icon="fas fa-filter"
  //   跟 CardTemplatesTab.js / StudentsListTab.js filter dropdown 同款 (less/forum.less L164-185)
  //
  // v0.6.62b — OperationLogs dropdown menu 错位修复 (辉哥 9/30 21:36 反馈)
  //   加 lazyDraw={true} prop, 阻止 shown.bs.dropdown 时 m.redraw() 触发异步重渲染
  //   (mithril 重渲染会把 menu 元素 className 重置回 'Dropdown-menu dropdown-menu ...', 抹掉 Bootstrap .show class, 造成 menu display:none 不可见)
  //   lazyDraw=true 时只 m.redraw.sync() 一次性同步渲染, 跳过 if (!lazyDraw) { m.redraw(); }
  //   同步参考: vendor/flarum/core/js/src/admin/components/PermissionsPage.tsx (Flarum 自身就用 lazyDraw)
  renderFilter() {
    return m("div", {
      className: "ZS-log-filter"
    }, m("span", {
      className: "ZS-log-filter-label"
    }, "\u65E5\u671F:"), m("input", {
      type: "text",
      className: "ZS-date-input-text ZS-log-date-picker",
      value: this.selectedDate
    }), m("span", {
      className: "ZS-log-filter-label"
    }, "\u64CD\u4F5C\u7C7B\u578B:"), m(Dropdown, {
      buttonClassName: "ZS-filter-dropdown-btn",
      icon: "fas fa-filter",
      label: this.selectedActionLabel(),
      menuClassName: "Dropdown-menu--right ZS-log-action-menu",
      lazyDraw: true
    }, this.actionOptions().map(opt => m(Button, {
      key: opt.value,
      active: this.selectedAction === opt.value,
      onclick: () => this.setAction(opt.value)
    }, opt.label))));
  }
  view() {
    const meta = this.meta;
    const total = this.totalCount();
    // v0.17.16 — 「已全部加载」只在**真的翻过页**之后才显示:
    //   一屏装得下的日期 (比如今天只有 5 条) 根本没有滚动, 在那里加结束语是纯噪音;
    //   滚到底的用户则需要明确知道「到底了」, 以便区分「数据完了」和「滚动卡住了」。
    const showEnd = !!meta && !meta.has_more && this.paginatedOnce;
    return m("div", {
      className: "ZS-operation-logs-tab"
    }, this.renderFilter(), !this.loading && meta && !this.needSchool && m("div", {
      className: "ZS-log-summary"
    }, "\u5171 ", total, " \u6761", this.logs.length < total ? m("span", null, "\uFF08\u5DF2\u52A0\u8F7D ", this.logs.length, " \u6761\uFF0C\u7EE7\u7EED\u4E0B\u6ED1\u52A0\u8F7D\u66F4\u591A\uFF09") : null), this.loading && m("div", {
      className: "ZS-log-loading"
    }, "\u52A0\u8F7D\u4E2D..."), !this.loading && this.logs.length === 0 &&
    /* v0.18.57 — 「请先选校区」与「没数据」是**两回事**, 文案必须分开。
       ⚠️ 只换文案: 用的还是同一个 .ZS-log-empty, 布局/颜色/字号/图标一律不动。
       ⚠️ need_school 为 false / 缺失时, 渲染结果与改前**逐字一致**。 */
    m("div", {
      className: "ZS-log-empty"
    }, this.needSchool ? '请先选择校区后查看操作日志' : '暂无操作记录'), !this.loading && this.logs.length > 0 && m("div", {
      className: "ZS-log-list"
    }, this.logs.map(log => this.rowView(log)), meta && meta.has_more && m("div", {
      className: "ZS-log-sentinel",
      "data-zlogsid": this._sid,
      "aria-hidden": "true"
    }), this.loadingMore && m("div", {
      className: "ZS-log-loading-more"
    }, m("i", {
      className: "fas fa-spinner fa-spin",
      "aria-hidden": "true"
    }), " \u6B63\u5728\u52A0\u8F7D\u2026"), showEnd && m("div", {
      className: "ZS-log-end"
    }, "\u5DF2\u5168\u90E8\u52A0\u8F7D\uFF08\u5171 ", total, " \u6761\uFF09")));
  }
}
flarum.reg.add('ziiven-ziven-scheduler', 'forum/components/OperationLogsTab', OperationLogsTab);